import React from 'react';
import type { IRowDetails } from '../types/TableRows';
import { formatToTwoDecimals } from '../utils/format-number';

interface SelectedRowProps {
  data: IRowDetails | undefined;
}

const SelectedRowDisplay: React.FC<SelectedRowProps> = ({ data }) => {
  if (!data) return null;

  const twoDecimalFields: (keyof IRowDetails)[] = [
    'marketValueLocalVariance',
    'priceLocalManager',
    'priceLocalBank',
    'priceLocalVariance',
    'marketValueLocalManager',
    'marketValueLocalBank',
    'marketValueBaseManager',
    'marketValueBaseBank',
    'marketValueBaseVariance',
    'priceBaseManager',
    'marketValueManagerUsd',
    'marketValueBankUsd',
    'marketValueVarianceUsd',
    'mktValueLocalPctVariance',
    'quantityManager',
    'quantityBank',
    'quantityVariance',
    'exchangeRateManager',
    'exchangeRateBank',
    'priceBaseBank',
  ];

  const formatFieldValue = (key: keyof IRowDetails, value: string): string => {
    if (twoDecimalFields.includes(key)) {
      return formatToTwoDecimals(value);
    }

    return value;
  };

  const fields: { label: string; key: keyof IRowDetails }[] = [
    { label: 'Data as of', key: 'effectiveDate' },
    { label: 'Type', key: 'type' },
    { label: 'Security Type Manager', key: 'securityTypeManager' },
    { label: 'Security Description Manager', key: 'securityDescriptionManager' },
    { label: 'Security Description Bank', key: 'securityDescriptionBank' },
    { label: 'Market Value Local Variance', key: 'marketValueLocalVariance' },
    { label: 'Market Value Variance (%)', key: 'mktValueLocalPctVariance' },
    { label: 'Next Review Date', key: 'nextReviewDate' },
    { label: 'Account Name', key: 'accountName' },
    { label: 'OCIO Analyst Name', key: 'ocioTradeOpsAnalystFullname' },
    { label: 'OCIO Analyst 2 Name', key: 'ocioTradeOpsAnalyst2Fullname' },
    { label: 'Match ID', key: 'matchId' },
    { label: 'Client ID', key: 'clientId' },
    { label: 'Custodian Name', key: 'custodianName' },
    { label: 'Custodian Account Number', key: 'custodianAccountNumber' },
    { label: 'Security ID Manager', key: 'securityIdManager' },
    { label: 'Security ID Bank', key: 'securityIdBank' },
    { label: 'Quantity Manager', key: 'quantityManager' },
    { label: 'Quantity Bank', key: 'quantityBank' },
    { label: 'Quantity Variance', key: 'quantityVariance' },
    { label: 'Price Local Manager', key: 'priceLocalManager' },
    { label: 'Price Local Bank', key: 'priceLocalBank' },
    { label: 'Price Local Variance', key: 'priceLocalVariance' },
    { label: 'Market Value Local Manager', key: 'marketValueLocalManager' },
    { label: 'Market Value Local Bank', key: 'marketValueLocalBank' },
    { label: 'Break Age', key: 'breakAge' },
    { label: 'Market Value Base Manager', key: 'marketValueBaseManager' },
    { label: 'Market Value Base Bank', key: 'marketValueBaseBank' },
    { label: 'Market Value Base Variance', key: 'marketValueBaseVariance' },
    { label: 'Currency Manager', key: 'currencyManager' },
    { label: 'Currency Bank', key: 'currencyBank' },
    { label: 'Exchange Rate Manager', key: 'exchangeRateManager' },
    { label: 'Exchange Rate Bank', key: 'exchangeRateBank' },
    { label: 'Price Base Manager', key: 'priceBaseManager' },
    { label: 'Price Base Bank', key: 'priceBaseBank' },
    { label: 'Market Value Manager USD', key: 'marketValueManagerUsd' },
    { label: 'Market Value Bank USD', key: 'marketValueBankUsd' },
    { label: 'Market Value Variance USD', key: 'marketValueVarianceUsd' },
    { label: 'Stp Comment', key: 'stpComment' },
    { label: 'Break ID', key: 'breakId' },
  ];

  return (
    <div className="h-[400px] overflow-auto">
      <table style={{ borderCollapse: 'collapse', width: '100%' }}>
        <tbody>
          {fields.map(({ label, key }) => (
            <tr key={key}>
              <td style={{ border: '1px solid #ccc', padding: '8px', fontWeight: 'bold' }}>{label}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{formatFieldValue(key, data[key])}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SelectedRowDisplay;
